import { ActivatedRoute, Router } from '@angular/router';
var ComponentComment = (function () {
    function ComponentComment(route, router) {
        this.route = route;
        this.router = router;
    }
    ComponentComment.prototype.ngOnInit = function () {
        var _this = this;
        var list = JSON.parse(JSON.stringify(this.commentList));
        list.map(function (item) {
            var time = null;
            if (item.studentCommentAt && typeof (item.studentCommentAt) != "undefined") {
                time = item.studentCommentAt.split('.')[0].split('T');
                item.studentCommentAt = time[0] + " " + time[1].split(":")[0] + ":" + time[1].split(":")[1];
            }
            if (item.studentCommentByName.length > 10) {
                item.studentCommentByName = item.studentCommentByName.slice(0, 10) + "...";
            }
        });
        this.commentList = list;
        this.route.queryParams.subscribe(function (queryParams) {
            _this.commentFlag = !!queryParams['commentFlag'];
            _this.relationIdUrl = queryParams['relationId'];
        });
    };
    ComponentComment.prototype.ngAfterViewInit = function () {
        var _this = this;
        if (this.commentFlag) {
            //评论后跳转到对应位置
            var index_1 = null;
            if (this.tabNum == 1) {
                this.studentList.forEach(function (item) {
                    if (item['userCampExerciseQuestionOperationLogVO'].relationId == _this.relationIdUrl) {
                        index_1 = item['userCampExerciseQuestionOperationLogVO'].studentCommentList.length - 1;
                    }
                });
            }
            else if (this.tabNum == 0) {
                index_1 = this.commentList.length - 1;
            }
            var ele = document.querySelector(".single_comment-" + this.relationIdUrl + "-" + index_1);
            if (ele) {
                ele.scrollIntoView();
            }
        }
    };
    return ComponentComment;
}());
export { ComponentComment };



// WEBPACK FOOTER //
// ./src/component/comment/component.comment.ts.pre-build-optimizer.js